import formAppCanvas2 from './formAppCanvas2';
import formAppCanvasAPIUrls from './formAppCanvasAPIUrls';
import formSportRoomsLegacy from './formSportRoomsLegacy';
import formSportRoomsTabsLegacy from './formSportRoomsTabsLegacy';


export default {
  title: 'Space Canvas Customization',
  attributeName: 'appCanvas',
  getURL: 'appId/areaId/appCanvas',
  createURL: '',
  updateURL: 'appId/areaId/appCanvas',
  removeURL: '',
  autoUpdate: true,
  sessionParams: ['appId', 'areaId'],
  showOperatingSystem:true,
  formConfig: [
    formSportRoomsLegacy,
    formSportRoomsTabsLegacy,
    formAppCanvas2,
    formAppCanvasAPIUrls,
  ],
};
